import { c as _c } from "react/compiler-runtime";
import { Stack } from '@mui/material';
import { SearchTextBox } from './searchTextBox';
import { AddButton } from '../buttons/addButton';
export const SearchBar = t0 => {
  const $ = _c(23);
  const {
    value,
    setValue,
    placeholder,
    selectedValues,
    onAddClick,
    showAddButton,
    hideSearchIcon
  } = t0;
  let t1;
  if ($[0] !== onAddClick || $[1] !== selectedValues || $[2] !== setValue || $[3] !== showAddButton || $[4] !== value) {
    t1 = () => {
      if (showAddButton && onAddClick) {
        const values = [...selectedValues, value];
        onAddClick(values);
        setValue("");
      }
    };
    $[0] = onAddClick;
    $[1] = selectedValues;
    $[2] = setValue;
    $[3] = showAddButton;
    $[4] = value;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const addCallback = t1;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      alignItems: "center",
      paddingY: "12px",
      gap: "12px"
    };
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      flexGrow: 1
    };
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = showAddButton && onAddClick ? addCallback : undefined;
  let t5;
  if ($[8] !== hideSearchIcon || $[9] !== placeholder || $[10] !== setValue || $[11] !== t4 || $[12] !== value) {
    t5 = <SearchTextBox value={value} onChange={setValue} placeholder={placeholder} sx={t3} hideIcon={hideSearchIcon} onEnter={t4} />;
    $[8] = hideSearchIcon;
    $[9] = placeholder;
    $[10] = setValue;
    $[11] = t4;
    $[12] = value;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== addCallback || $[15] !== onAddClick || $[16] !== selectedValues || $[17] !== showAddButton || $[18] !== value) {
    t6 = showAddButton && onAddClick && <AddButton disabled={selectedValues.includes(value) || !value} onClick={addCallback} />;
    $[14] = addCallback;
    $[15] = onAddClick;
    $[16] = selectedValues;
    $[17] = showAddButton;
    $[18] = value;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t5 || $[21] !== t6) {
    t7 = <Stack direction="row" className="w-full" sx={t2}>{t5}{t6}</Stack>;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};